import React from 'react';
import './Hero.css';

export default function Hero() {
  return (
    <div className="hero-banner">
      <div className="hero-overlay">
        <h1 className="hero-title">Welcome to LearningGuide Academy</h1>
      </div>
    </div>
  );
}
